"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSkuToJSON = exports.ProductSkuFromJSONTyped = exports.ProductSkuFromJSON = exports.instanceOfProductSku = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ProductSku interface.
 */
function instanceOfProductSku(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductSku = instanceOfProductSku;
function ProductSkuFromJSON(json) {
    return ProductSkuFromJSONTyped(json, false);
}
exports.ProductSkuFromJSON = ProductSkuFromJSON;
function ProductSkuFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'sku': !(0, runtime_1.exists)(json, 'sku') ? undefined : json['sku'],
        'sort': !(0, runtime_1.exists)(json, 'sort') ? undefined : json['sort'],
        'ean': !(0, runtime_1.exists)(json, 'ean') ? undefined : json['ean'],
        'inBox': !(0, runtime_1.exists)(json, 'inBox') ? undefined : json['inBox'],
    };
}
exports.ProductSkuFromJSONTyped = ProductSkuFromJSONTyped;
function ProductSkuToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'sku': value.sku,
        'ean': value.ean,
        'inBox': value.inBox,
    };
}
exports.ProductSkuToJSON = ProductSkuToJSON;
